// Project scope identifier used to filter rows / objects that belong to this site.
export const PROJECT_ID = (import.meta.env.VITE_PUBLIC_PROJECT_ID as string) || '';